import type { RelativePerformanceNormalizedSeries, RelativePerformanceTableRow } from './Comparison.types';
import { useComparisonNormalization } from './useComparisonNormalization';
import { useComparisonTimeseries } from './useComparisonTimeseries';

interface UseComparisonDataParams {
  cmAssetIds: string[];
  metric: string;
  startDate: string;
  endDate: string;
  talosSymbolByCmAssetId: ReadonlyMap<string, string>;
}

interface UseComparisonDataResult {
  normalizedSeries: RelativePerformanceNormalizedSeries[];
  absoluteSeries: RelativePerformanceNormalizedSeries[];
  tableRows: RelativePerformanceTableRow[];
  excludedCmAssetIds: string[];
  isFetching: boolean;
  isError: boolean;
  isTruncated: boolean;
}

export function useComparisonData({
  cmAssetIds,
  metric,
  startDate,
  endDate,
  talosSymbolByCmAssetId,
}: UseComparisonDataParams): UseComparisonDataResult {
  const { dataByAsset, isFetching, isError, isTruncated } = useComparisonTimeseries({
    cmAssetIds,
    metric,
  });

  const { normalizedSeries, absoluteSeries, tableRows, excludedCmAssetIds } = useComparisonNormalization({
    dataByAsset,
    metric,
    startDate,
    endDate,
    selectedCmAssetIds: cmAssetIds,
    talosSymbolByCmAssetId,
  });

  return { normalizedSeries, absoluteSeries, tableRows, excludedCmAssetIds, isFetching, isError, isTruncated };
}
